// Selects a color based on a string hash (e.g. traveler name), used for Avatar color backgrounds
export const getColorFromString = (str) => {
  const colors = ['#194145', '#bb806d', '#5D2E24', '#533462', '#B18C63', '#A2A39C'];

  if (!str) {
    return colors[0];
  }

  const hashedNum = str?.split('').reduce((prev, curr) => {
    return prev + curr?.charCodeAt(0);
  }, 0);
  const index = hashedNum % colors?.length;

  return colors?.[index];
};
